const searchOptions = [
  {
    label: "Macro",
    value: "Macro"
  },
  {
    label: "Industry",
    value: "Industry"
  },
  {
    label: "Company",
    value: "Company"
  },
  {
    label: "M&A transactions",
    value: "M&A transactions"
  }
];

export default searchOptions;